import React from "react";
import Modal from "./Modal";

const ModalConfirm: React.FC<{
  onConfirm: () => void;
  onClose: () => void;
  text: string;
}> = ({ onConfirm, onClose, text }) => {
  const confirmAndCloseModal = () => {
    onConfirm();
    onClose();
  };
  return (
    <Modal onClose={onClose} title="Are you sure?" >
      <p className="text-[#1D1E22] ">{text}</p>
      <div className="mt-7 ml-auto">
        <button onClick={onClose} className="w-[114px] h-[40px] border-[#1D1E22] border">Cancel</button>
        <button onClick={confirmAndCloseModal} className="w-[114px] h-[40px] text-[#E4EFF9] bg-[#06B4FF] border border-[#06B4FF] rounded-none ml-6">
          Confirm
        </button>
      </div>
    </Modal>
  );
};

export default ModalConfirm;
